import React from 'react'

import Creatable from "react-select/creatable";
import AsyncPaginate from 'react-select-async-paginate';

import FetchHelper from '../../utils/FetchHelper'

export default class AsyncSelect extends React.Component  {
  constructor(props){
    super(props)

    this.state = {
      ...this._getState(props),
      search: '',
      prevSearch: '',
      items: [],
      nextPageUrl: null,
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(this._getState(nextProps))
  }

  _getState(props){
    return {
      ...props,
      placeholder: props.placeholder,
      endpoint: props.endpoint,
      isMulti: props.isMulti ? props.isMulti : false,
      creatable: props.creatable ? props.creatable : false,
      styles: props.styles,
      filter: props.filter ? props.filter : '',
      value: props.value,
      disabled: props.disabled
    }
  }

  _loadOptions(search, prevOptions){
    let {
      endpoint,
      prevSearch,
      nextPageUrl,
      filter,
      items
    } = this.state

    let statusCode = null

    const website = window.CURRENT_WEBSITE

    let headers = {
      'Content-Type': 'application/json',
      'funnelReferenceId': website.funnel_reference_id,
    }

    if(endpoint.indexOf("providersApi") > -1){
      if(window.IS_EDIT_MODE) {
        headers['authorization'] = `Bearer ${website.user_token}`
      }else{
        headers['companyToken'] = website.company_token
      }
    }else{
      headers['companyToken'] = website.company_token
      headers['authorization'] = `Bearer ${website.user_token}`
    }

    let data = {
      campaignId: window.CURRENT_WEBSITE.campaign_id,
      filter1_column: "productName",
      filter1_condition: "contains",
      filter1_value: search
    }

    return fetch(endpoint, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    }).then(response => {
      statusCode = response.status
      if (statusCode == 204) {
        return response
      }
      return response.json()
    }).then((response) => {

      let results = Object.entries(response.message)
      if(["Token/Authorization is needed",
        "No campaigns matching those parameters could be found",
        "No products matching those parameters could be found"].includes(response.message)){
        results = []
      }

      let newOptions = this.props.getOptions(results)

      items = results

      this.setState({
        items,
        nextPageUrl: null,
        prevSearch: search
      })
      return {
        options: newOptions,
        hasMore: false
      }
    })
  };

  _handleChange(option){
    if(this.state.isMulti){
      this.setState({ value: option }, () =>{
        this.props.onSelected(this.state.value)
      })
    }
    else if(!option){
      this.setState({ value: option }, () => {
        this.props.onSelected(option)
      })
    }
    else if(option.__isNew__){
      this.setState({ value: option }, () => {
        this.props.onCreated(option)
      })
    } else{
      this.setState({ value: option }, () => {
        this.props.onSelected(option.data)
      })
    }
  }

  render(){
    let props = {...this.props}

    if(this.state.creatable){
      props.SelectComponent = Creatable
    }
    return (
      <AsyncPaginate
        { ...props }
        isMulti={this.props.isMulti}
        value={this.state.value || ''}
        closeMenuOnSelect={!this.state.isMulti}
        loadOptions={this._loadOptions.bind(this)}
        debounceTimeout={500}
        onChange={value => {
          this._handleChange(value)
        }}
        onBlur={() => this.props.onBlur()}
        isDisabled={this.state.disabled}
        menuPortalTarget={document.body}
        styles={{ menuPortal: base => ({ ...base, zIndex: 9999, ...this.state.styles }) }}
      />
    )
  }
}

AsyncSelect.defaultProps = {
  isMulti: false,
  orderBy: "name",
  onBlur: () => null,
  validateTokens: false,
  styles: {}
}
